import { render, staticRenderFns } from "./ErrorSnackBar.vue?vue&type=template&id=d481ddae&"
import script from "./ErrorSnackBar.vue?vue&type=script&lang=js&"
export * from "./ErrorSnackBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports